module.exports = __webpack_public_path__ + "img/chevron-left.44ec89ba.svg";